import { ContainedTextInput as BaseContainedTextInput } from 'components/forms/ContainedTextInput';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const ContainedTextInput = styled(BaseContainedTextInput)`
    width: 9.6rem;
    height: 2.4rem;
`;

export const Callout = styled.div`
    background-color: ${tokens.surface.subtle};
    border-radius: 8px;
    padding: 0.8rem 1.2rem;
    color: ${tokens.text.primary};
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

export const ContentStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
`;

export const SectionDescription = styled.p`
    font-size: 1.4rem;
    line-height: 1.8rem;
    margin: 0 0 0.8rem 0;
`;

export const DisabledHint = styled.div`
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${tokens.text.secondary};
`;

export const FooterButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    width: 100%;
`;
